<template>
  <div v-if="type === 'simple'" class="v-no-data">{{title}}</div>
  <div v-else class="v-no-data whole">
    <div class="icon-wrapper">
      <v-icon :type="icon" size="88"></v-icon>
    </div>
    <div class="txt">
      <h3>{{title}}</h3>
      <p>{{subtitle}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  props: {
    title: {
      type: String,
      default: '暂无搜索结果',
    },
    type: {
      type: String,
      default: 'simple',
      validator(value) {
        return ['simple', 'whole'].indexOf(value) !== -1;
      },
    },
    icon: String,
    subtitle: String,
  },
};
</script>

<style lang="less">
  .v-no-data{
    color: rgba(0, 0, 0, 0.26);
    line-height: 32px;
    font-size: 24px;
    &.whole{
      text-align: center;
    }
    .icon-wrapper{
      width: 168px;
      height: 168px;
      background-color: rgba(0, 0, 0, 0.08);
      border-radius: 50%;
      padding-top: 40px;
      margin-bottom: 8px;
      display: inline-block;
    }
    .txt{
      h3{
        color: rgba(0, 0, 0, 0.26);
        line-height: 32px;
        font-size: 24px;
        margin-bottom: 8px;
      }
      p{
        color: rgba(0, 0, 0, 0.26);
        line-height: 32px;
        font-size: 14px;
      }
    }
    .v-icon{
      color: rgba(0, 0, 0, 0.12);
    }
  }
</style>
